import React, { useRef, useState } from 'react';

import { Card, ListGroup } from 'react-bootstrap';

import BookPage from './BookPage';
import CodeArea from './CodeArea';

import image01_01 from './res/dependency_dialog.png';

import image02_01 from './res/2_1.png';
import image02_02 from './res/2_2.png';

import image03_01 from './res/3_1.png';
import image03_02 from './res/3_2.png';

import image_structure from './res/file_strucrture.png';


function Documents(props) {
  const ref_ = useRef(null);
  const updateIndex = (next) => {
    if (ref_.current === null) return;
    ref_.current.setIndex(next);
  };

  const FeaturesFirstIndex = 0;
  const TryDemoFirstIndex = 1;
  const HowToUseFirstIndex = 2;
  const FileStructureFirstIndex = 5;
  const SampleScenesFirstIndex = 6;
  const AdvancedFirstIndex = 7;
  const TroubleShootingFirstIndex = 11;

  const [info, setInfo] = useState(
    [
      {
        firstIndex:FeaturesFirstIndex,
        title:"Features",
        contents:
        [
          {
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Features</h2></div>

              <div
                style={{
                  marginTop:40,
                  textAlign:"left",
                }}
              >
                Following features of the After Effects are available:
              </div>

              <div
                style={{
                  marginTop:20,
                  textAlign:"left",
                }}
              >
              <ListGroup
              >
                <ListGroup.Item>Position</ListGroup.Item>
                <ListGroup.Item>Rotation</ListGroup.Item>
                <ListGroup.Item>Scale</ListGroup.Item>
                <ListGroup.Item>Anhor point</ListGroup.Item>
                <ListGroup.Item>Opacity</ListGroup.Item>
                <ListGroup.Item>Color overlay</ListGroup.Item>
                <ListGroup.Item>Image file footage</ListGroup.Item>
                <ListGroup.Item>Solid footage</ListGroup.Item>
                <ListGroup.Item>Shape mask</ListGroup.Item>
                <ListGroup.Item>Layer parent link</ListGroup.Item>
                <ListGroup.Item>Layer click event</ListGroup.Item>
                <ListGroup.Item>Start from marker</ListGroup.Item>
                <ListGroup.Item>Loop between markers</ListGroup.Item>
                <ListGroup.Item>Pause and resume</ListGroup.Item>
                <ListGroup.Item>Preloading</ListGroup.Item>
                <ListGroup.Item>Prefab Cache</ListGroup.Item>
                <ListGroup.Item>Swap images</ListGroup.Item>
              </ListGroup>
              </div>


              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={
                  ()=>{
                    updateIndex(TryDemoFirstIndex);
                  }
                }
              ><h5>Next:Try Demo</h5></div>
              </p>
            )  
          }
        ]
      },
      {
        firstIndex:TryDemoFirstIndex,
        title:"Try Demo",
        contents:
        [
          {
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Try Demo</h2></div>

              <div
              style={{
                marginTop:60
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    1
                  </Card.Title>
                  <Card.Text>
                  Download and import AEAsAnimation.<br />
                  Press Install/Upgrade button when the dependency dialog asks.
                  </Card.Text>
                </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:10
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    2
                  </Card.Title>
                  <Card.Text>
                  Open SampleScene01, and play it.
                  </Card.Text>
                </Card.Body>
              </Card></div>


              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={
                  ()=>{
                    updateIndex(HowToUseFirstIndex);
                  }
                }
              ><h5>Next:Get started - Import AEAsAnimation</h5></div>
              </p>
            )  
          }
        ]
      },
      {
        firstIndex:HowToUseFirstIndex,
        title:"How to use",
        contents:
        [
          {
            index:(HowToUseFirstIndex + 0),
            subTitle:" - Export AE animation",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Export AE animation</h2></div>
  
              <div
              style={{
                marginTop:60
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    1
                  </Card.Title>
                  <Card.Text>
                  Open After Effcts and select the composition
                  </Card.Text>
                  <Card.Img
                  src={image02_01}
                  style = {{
                    width:800,
                    height:400,
                  }} />
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                marginTop:10
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    2
                  </Card.Title>
                  <Card.Text>
                  Run the convert script.<br/>
                  The convert script is here : AEAsAnimation/AEPlugin/after-effects-as-animation.jsx
                  </Card.Text>
                  <Card.Img
                  src={image02_02}
                  style = {{
                    width:800,
                    height:1000,
                  }} />
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                marginTop:10
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    3
                  </Card.Title>
                  <Card.Text>
                  Then, the animation file for Unity will be placed on your desktop.
                  </Card.Text>
                </Card.Body>
              </Card></div>
  
  
              <div
              style={{
                cursor:"pointer",
                userSelect:"none",
                MozUserSelect:"none",
                WebkitUserSelect:"none",
                msUserSelect:"none",
  
                marginTop:60
              }}
              onClick={()=>updateIndex((HowToUseFirstIndex + 1))}
            ><h5>Next:Install animation files</h5></div>
            </p>
           )  
          },
          {
            index:(HowToUseFirstIndex + 1),
            subTitle:" - Install animation files",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Install animation files</h2></div>
  
              <div
              style={{
                marginTop:60
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    1
                  </Card.Title>
                  <Card.Text>
                  Create the streaming assets direcory in your Unity project.
                  </Card.Text>
                  <Card.Img
                  src={image03_01}
                  style = {{
                    width:260,
                    height:168,
                  }} />
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                marginTop:10
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    2
                  </Card.Title>
                  <Card.Text>
                  Move the animation file into your streaming assets direcory.
                  </Card.Text>
                  <Card.Img
                  src={image03_02}
                  style = {{
                    width:432,
                    height:276,
                  }} />
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                marginTop:10
              }}
              ><Card>
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    3
                  </Card.Title>
                  <Card.Text>
                  If the animation requires resource files, Move those files into the streaming assets direcory.<br />
                  Those resource files must be placed in same directory as the animation file.
                  </Card.Text>
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                cursor:"pointer",
                userSelect:"none",
                MozUserSelect:"none",
                WebkitUserSelect:"none",
                msUserSelect:"none",
  
                marginTop:60
              }}
              onClick={()=>updateIndex((HowToUseFirstIndex + 2))}
            ><h5>Next:Show animation on Unity</h5></div>
            </p>
            )  
          },
          {
            index:(HowToUseFirstIndex + 2),
            subTitle:" - Show animation on Unity",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Show animation on Unity</h2></div>
  
              <div
              style={{
                marginTop:60
              }}
              ><Card>                
                <Card.Body
                style = {{
                  textAlign:"left"
                }}>
                  <Card.Title>
                    1
                  </Card.Title>
                  <Card.Text>
                  Add the following code to your Unity project to play the animation.<br />
                  <CodeArea
                    lines ={[
                      {
                        body:"AEAsAnimation.AEasAnimationRoot.Show(\"path/to/file\");",
                        index:0
                      },
                    ]}
                  />

                  </Card.Text>
                </Card.Body>
              </Card></div>
  
              <div
              style={{
                cursor:"pointer",
                userSelect:"none",
                MozUserSelect:"none",
                WebkitUserSelect:"none",
                msUserSelect:"none",
  
                marginTop:60
              }}
              onClick={()=>updateIndex(FileStructureFirstIndex)}
              ><h5>Next:File Structure</h5></div>
  
            </p>
            )
          }
        ]
      },
      {
        firstIndex:FileStructureFirstIndex,
        title:"File Structure",
        contents:
        [
          {
            index:FileStructureFirstIndex,
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>File Structure</h2></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              > <Card>
              <Card.Body>
              <Card.Img
                  src={image_structure}
                  style = {{
                    width:337,
                    height:432,
                  }} />
              </Card.Body>
              </Card></div>


              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              > <Card>
              <Card.Body>
              <div
              style={{
                color:"#aa3333"
              }}>
              AEAsAnimation/AEPlugIn
              </div>
              <div
              style={{
                marginTop:10
              }}>
              This directory contains the After Effects plugin jsx file.<br/>
              Running this jsx to convert the After Effects animation to the json data for Unity.
              </div>
              </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              > <Card>
              <Card.Body>
              <div
              style={{
                color:"#aa3333"
              }}>
              AEAsAnimation/MiniJson
              </div>
              <div
              style={{
                marginTop:10
              }}>
              This directory contains the MiniJson files.<br/>
              If your Unity project already import the MiniJson, you must remove this directory.
              </div>
              </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              > <Card>
              <Card.Body>
              <div
              style={{
                color:"#aa3333"
              }}>
              AEAsAnimation/Demo
              </div>
              <div
              style={{
                marginTop:10
              }}>
              Those directories contains the AEAsAnimation sample files.
              </div>
              </Card.Body>
              </Card></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              > <Card>
              <Card.Body>
              <div
              style={{
                color:"#aa3333"
              }}>
              AEAsAnimation/Scripts<br/>
              AEAsAnimation/Prefabs<br/>
              AEAsAnimation/Resources<br/>
              </div>
              <div
              style={{
                marginTop:10
              }}>
              Those directories contains the AEAsAnimation library files.
              </div>
              </Card.Body>
              </Card></div>

              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(SampleScenesFirstIndex)}
              ><h5>Next:Sample Scenes</h5></div>
              </p>
            )  
          }
        ]
      },
      {
        firstIndex:SampleScenesFirstIndex,
        title:"Sample Scenes",
        contents:
        [
          {
            index:SampleScenesFirstIndex,
            subTitle:"",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Sample Scenes</h2></div>
  

              <div
                  style={{
                    marginTop:60
                  }}>
                  <h5>SampleScene01 : Play animation</h5>
                  </div>
              <div
              style={{
                marginTop:10,
                textAlign:"left"
              }}
              ><Card>
                <Card.Body>
                <div>
                This is a simple playing animation sample.
                </div>
                <hr/>

                <div
                style={{
                  marginTop:10
                }}>
                The scene file is here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/Scenes/SampleScene01.unity
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The animation data files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                StreamingAssets/AEAsAnimation/Samples/RawAEFiles/Treasure/
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The AE files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/RawAEFiles/Treasure/
                </div>
                </Card.Body>
              </Card></div>




              <div
                  style={{
                    marginTop:60
                  }}>
                  <h5>SampleScene02:Loop</h5>
                  </div>
              <div
              style={{
                marginTop:10,
                textAlign:"left"
              }}
              ><Card>
                <Card.Body>
                <div>
                This is a loop animation sample.
                </div>
                <hr/>

                <div
                style={{
                  marginTop:10
                }}>
                The scene file is here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/Scenes/SampleScene02.unity
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The animation data files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                StreamingAssets/AEAsAnimation/Samples/RawAEFiles/Arrow/
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The AE files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/RawAEFiles/Arrow/
                </div>
                </Card.Body>
              </Card></div>



              <div
                  style={{
                    marginTop:60
                  }}>
                  <h5>SampleScene03:Mask</h5>
                  </div>
              <div
              style={{
                marginTop:10,
                textAlign:"left"
              }}
              ><Card>
                <Card.Body>
                <div>
                This is a sample animation with mask.
                </div>
                <hr/>

                <div
                style={{
                  marginTop:10
                }}>
                The scene file is here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/Scenes/SampleScene03.unity
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The animation data files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                StreamingAssets/AEAsAnimation/Samples/RawAEFiles/Mask/
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The AE files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/RawAEFiles/Mask/
                </div>
                </Card.Body>
              </Card></div>



              <div
                  style={{
                    marginTop:60
                  }}>
                  <h5>SampleScene04:Button event</h5>
                  </div>
              <div
              style={{
                marginTop:10,
                textAlign:"left"
              }}
              ><Card>
                <Card.Body>
                <div>
                This is a handling button events sample.
                </div>
                <hr/>

                <div
                style={{
                  marginTop:10
                }}>
                The scene file is here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/Scenes/SampleScene04.unity
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The animation data files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                StreamingAssets/AEAsAnimation/Samples/RawAEFiles/Button/
                </div>

                <div
                style={{
                  marginTop:10
                }}>
                The AE files are here :
                </div>
                <div
                style={{
                  color:"#aa3333"
                }}>
                AEAsAnimation/Demo/RawAEFiles/Button/
                </div>
                </Card.Body>
              </Card></div>


              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(AdvancedFirstIndex)}
              ><h5>Next:Advanced - Swap images</h5></div>
  
              </p>
            )  
          }
        ]
      },
      {
        firstIndex:AdvancedFirstIndex,
        title:"Advanced",
        contents:
        [
          {
            index:AdvancedFirstIndex,
            subTitle:" - Swap images",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Swap images</h2></div>
              
              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              You can use AddSwapImages() to swap images in the animation.
              </div>

              <CodeArea
              lines = {[
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform);",
                    indent:0
                  },
                  {
                    body:"animation.AddSwapImages(\"from.png\", \"to.png\");",
                    indent:0
                  },
                  {
                    body:"animation.Show(",
                    indent:0
                  },
                  {
                    body:"\"path/to/data\",",
                    indent:1
                  },
                  {
                    body:"root => {",
                    indent:1
                  },
                  {
                    body:"// In this animation, from.png is replaced by to.png.",
                    indent:2
                  },
                  {
                    body:"});",
                    indent:0
                  }
                ]}
              />

              <div
              style={{
                marginTop:40,
                textAlign:"left"
              }}
              >
              AddSwapImages() must be called before Show().<br/>
              Otherwise, use SwapImage().
              </div>

              <CodeArea
                lines ={[
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform)",
                    indent:0
                  },
                  {
                    body:"animation.Show(",
                    indent:0
                  },
                  {
                    body:"\"path/to/data\",",
                    indent:1
                  },
                  {
                    body:"root => {",
                    indent:1
                  },
                  {
                    body:"root.SwapImage(\"from.png\",\"to.ong\")",
                    indent:2
                  },
                  {
                    body:"});",
                    indent:0
                  }
                ]}
              />

              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(AdvancedFirstIndex+1)}
              ><h5>Next:Access Layer GameObject</h5></div>
              </p>
            )  
          },
          {
            index:AdvancedFirstIndex+1,
            subTitle:" - Access Layer GameObject",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Access Layer GameObject</h2></div>
              
              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              Using GetLayerByName() to access the layer GameObject in animation.
              </div>

              <CodeArea
                lines ={[
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform)",
                    indent:0
                  },
                  {
                    body:"animation.Show(",
                    indent:0
                  },
                  {
                    body:"\"path/to/data\",",
                    indent:1
                  },
                  {
                    body:"root => {",
                    indent:1
                  },
                  {
                    body:"var layerGameObject = root.GetLayerByName(\"name of layer\")",
                    indent:2
                  },
                  {
                    body:"new GameObject(\"child\").transform.parent = layerGameObject.transform",
                    indent:2
                  },
                  {
                    body:"});",
                    indent:0
                  }
                ]}
              />

              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(AdvancedFirstIndex+2)}
              ><h5>Next:Handle click events</h5></div>
              </p>
            )  
          },
          {
            index:AdvancedFirstIndex+2,
            subTitle:" - Handle click events",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Handle click events</h2></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              
                If the composition name incledes "button", it becomes a button.
              </div>

              <CodeArea
                lines ={[
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform)",
                    indent:0
                  },
                  {
                    body:"animation.OnClick += tag => {",
                    indent:0
                  },
                  {
                    body:"// tag (= layer name) must include \"button\"",
                    indent:1
                  },
                  {
                    body:"Debug.Log(tag + \" clicked.\");",
                    indent:1
                  },
                  {
                    body:"};",
                    indent:0
                  }
                ]}
              />

              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(AdvancedFirstIndex+3)}
              ><h5>Next:Cache</h5></div>
              </p>
            )  
          },
          {
            index:AdvancedFirstIndex+3,
            subTitle:" - Cache",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>Cache</h2></div>

              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
                AEAsAnimationPool provides the prefab cache that can reduce loading time for creating animation prefab.
              </div>

              <CodeArea
                lines ={[
                  {
                    body:"void Start() {",
                    indent:0
                  },
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform)",
                    indent:1
                  },
                  {
                    body:"animation.Show(",
                    indent:1
                  },
                  {
                    body:"\"path/to/data\",",
                    indent:2
                  },
                  {
                    body:"root => {",
                    indent:2
                  },
                  {
                    body:"AEAsAnimationUtils.pool.Push(\"key\", root);",
                    indent:3
                  },
                  {
                    body:"});",
                    indent:1
                  },
                  {
                    body:"}",
                    indent:0
                  },
                  {
                    body:" ",
                    indent:0
                  },
                  {
                    body:"void Update() {",
                    indent:0
                  },
                  {
                    body:"if (Input.GetKeyDown(KeyCode.P)) {",
                    indent:1
                  },
                  {
                    body:"AEAsAnimationUtils.pool.Pop(\"key\", transform);",
                    indent:2
                  },
                  {
                    body:"}",
                    indent:1
                  },
                  {
                    body:"}",
                    indent:0
                  }
                ]}
              />

              <div
                style={{
                  cursor:"pointer",
                  userSelect:"none",
                  MozUserSelect:"none",
                  WebkitUserSelect:"none",
                  msUserSelect:"none",
  
                  marginTop:60
                }}
                onClick={()=>updateIndex(TroubleShootingFirstIndex)}
              ><h5>Next:Trouble Shooting</h5></div>

              </p>
            )  
          }
        ]
      }
      ,
      {
        firstIndex:TroubleShootingFirstIndex,
        title:"Trouble Shooting",
        contents:
        [
          {
            index:TroubleShootingFirstIndex,
            subTitle:" - The animation does not hold at last frame",
            body:
            (
              <p
              style={{
                textAlign:"center"
              }}>
              <div><h2>The animation does not hold at last frame</h2></div>
              
              <div
              style={{
                marginTop:60,
                textAlign:"left"
              }}
              >
              Depends on After Effects Settings, the animation has another last frame that is empty.<br/>
              Using AEAsAnimationRoot.GoToStart() with lastOffset to ignore that empty frame.
              </div>

              <CodeArea
              lines = {[
                  {
                    body:"var animation = AEAsAnimationRoot.Attach(transform);",
                    indent:0
                  },
                  {
                    body:"animation.Show(",
                    indent:0
                  },
                  {
                    body:"\"path/to/data\",",
                    indent:1
                  },
                  {
                    body:"root => {",
                    indent:1
                  },
                  {
                    body:"root.GoToStart(lastOffset:1);",
                    indent:2
                  },
                  {
                    body:"});",
                    indent:0
                  }
                ]}
              />

              </p>
            )  
          }
        ]
      }
    ]
    );

  return (
    <div>
      <BookPage
      documentInfos = {info}
      defaultIndex = {props.defaultIndex}
      ref = {ref_}
      />
    </div>
  );
}

export default Documents;
